import React from "react";
import BootstrapTable from "react-bootstrap-table-next";

import { useRoute } from "../../../../utils/useRoute";
import {
	NoRecordsFoundMessage,
	PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import { AddUserToGda } from "./AddUserToGda";
import { DeleteColumnFormatter } from "../../../../component/CellRowTable/DeleteColumnFormatter";
import { columnsGda } from "./gdaUserTableData";
import { useLanguageForShared } from "../../../../../shared/utils/languages/useLanguageForShared";

export function GdaUsersTable({
	users,
	selectedUsers = [],
	roles = [],
	addUser,
	removeUser,
}) {
	const {t} = useLanguageForShared()

	const { changeRoute } = useRoute();
	const getSelectRow = (props) => {
		return {
			mode: "checkbox",
			clickToSelect: false,
			hideSelectAll: true,
			hideSelectColumn: true,
		};
	};

	const dataTable = [
		...columnsGda(t),
		{
			dataField: "delete",
			text: "",
			formatter: DeleteColumnFormatter,
			formatExtraData: {
				deleteRow: removeUser,
			},
			classes: "",
			style: {
				maxWidth: "100px",
			},
		},
	];

	return (
		<>
			<AddUserToGda addableUsers={users} roles={roles} addUser={addUser} />
			<BootstrapTable
				wrapperClasses="table-responsive"
				bordered={false}
				classes="table table-head-custom table-vertical-center overflow-hidden"
				bootstrap4
				remote
				hover={false}
				keyField="id"
				data={selectedUsers}
				columns={dataTable}
				selectRow={getSelectRow({
					selectedUsers,
				})}>
				<PleaseWaitMessage entities={selectedUsers} />
				<NoRecordsFoundMessage entities={selectedUsers} />
			</BootstrapTable>
		</>
	);
}
